module.exports = __webpack_public_path__ + "img/ត្រី.54628c61.png";